import { Action } from '~/lib/authz';
import {
  AchTransferTemplateResponse,
  BookTransferTemplateResponse,
  TransferTemplateResponse,
  WireTransferTemplateResponse,
} from '~/repositories/Transfer/TransferTemplateRepository';

type TransferTemplateWithAccess = Omit<TransferTemplateResponse, 'achTransfers' | 'wireTransfers' | 'bookTransfers'> & {
  isPartialAccess: boolean;
  achTransfers?: AchTransferTemplateResponse[];
  wireTransfers?: WireTransferTemplateResponse[];
  bookTransfers?: BookTransferTemplateResponse[];
};

export const annotateTemplateAccess = (
  template: TransferTemplateResponse,
  isAuthorized: (action: Action) => boolean
): TransferTemplateWithAccess => {
  const annotatedTemplate = { ...template } as TransferTemplateWithAccess;

  const isRowVisible = <
    T extends AchTransferTemplateResponse | WireTransferTemplateResponse | BookTransferTemplateResponse,
  >(
    row: T
  ): boolean => {
    const bankAccountId =
      'bankAccountId' in row ? row.bankAccountId : 'senderBankAccountId' in row ? row.senderBankAccountId : undefined;
    if (!bankAccountId) return true;

    return isAuthorized({
      permission: 'bankAccounts',
      permissionLevel: 'read',
      bankAccount: { id: bankAccountId },
    });
  };

  if (annotatedTemplate.achTransfers) {
    annotatedTemplate.isPartialAccess = annotatedTemplate.achTransfers.some((row) => !isRowVisible(row));
  }

  if (annotatedTemplate.wireTransfers) {
    annotatedTemplate.isPartialAccess = annotatedTemplate.wireTransfers.some((row) => !isRowVisible(row));
  }

  if (annotatedTemplate.bookTransfers) {
    annotatedTemplate.isPartialAccess = annotatedTemplate.bookTransfers.some((row) => !isRowVisible(row));
  }

  return annotatedTemplate;
};
